export default {
      id: "first-usage",
      viewBox: "0 0 13 13",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#first",
      toString: function () {
        return this.url;
      }
    }